export class AcceleratorStatusRefresh {
  static readonly type = '[AcceleratorStatus] Refresh';
}
